import client from '@/config/directus.api';

const COLLECTION = 'w2p_projects';

class Project {
  constructor(payload) {
    this.title = payload.source.title;
    this.project_id = payload.projectId;
    this.design_id = payload.source.designId;
    this.company_id = { id: payload.source.userData.company_id };
    this.user_id = { id: payload.source.userData.user_id };
    this.category_id = payload.source.userData.category_id;
    this.pdf_version = payload.source.pdfVersion;
    this.layout = payload.source.layout;
    this.version = payload.source.version;
    this.previews = payload.previews[0];
  }
}

export function deleteProject(id) {
  return client
    .deleteItem(COLLECTION, id)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

export function getProjects(filter = {}) {
  return client
    .getItems(COLLECTION, {
      fields: '*, modified_by.*.*, created_by.*',
      sort: '-modified_on',
      filter
    })
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

export function getProject(id) {
  return client
    .get('/custom/templates/projects/' + id)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

export function saveProject(payload) {
  const data = new Project(payload);

  return client
    .createItem(COLLECTION, data)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

export function updateProject(id, payload) {
  const data = new Project(payload);

  return client
    .updateItem(COLLECTION, id, data)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}
